import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseStoreFacade } from '@city/data-access';
import { PromoService } from '@promo/data-access';
import { BannerComponent } from '@promo/ui';
import { BonusHistoryComponent } from '../../components';

@Component({
  selector: 'sd-points-page',
  templateUrl: './points-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BonusHistoryComponent, BannerComponent],
})
export class PointsPageComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private promoService = inject(PromoService);
  private baseStoreFacade = inject(BaseStoreFacade);

  ngOnInit(): void {
    this.baseStoreFacade
      .getActiveCode()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((baseStoreCode) => this.promoService.loadPromo(baseStoreCode));
  }
}
